var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MonthSelect"},[_c('van-datetime-picker',{attrs:{"type":"year-month","min-date":_vm.minDate,"max-date":_vm.maxDate,"formatter":_vm.formatter},on:{"confirm":_vm.onConfirm},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }